import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPredictionRuleModel from "./AbstractPredictionRuleModel.js";

/**
 * Compute data using a linear regression.
 *
 * @param {number} shift - Number of previous months
 *   to consider for the regression
 */
export default class LinearRegressionPredictionRuleModel extends AbstractPredictionRuleModel {
	constructor({ shift = 12 } = {}) {
		super(...arguments);

		this._shift = shift;
	}

	getShift() {
		return this._shift;
	}

	setShift(shift) {
		this._shift = shift;
	}

	accept(visitor) {
		return visitor.visitLinearRegressionPredictionRuleModel(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.shift = this._shift;

		return properties;
	}

	static getLabel() {
		return _("Linear regression");
	}

	static getType() {
		return "SimpleLinearRegression";
	}

	static getDescriptionText() {
		return _("Forecast based on the relationship between previous data");
	}
}
